import type { ReactNode } from 'react';
import { cn } from '@/libs/utils/cn';

interface InputProps {
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}

function Input({ className, type, ...props }: React.ComponentProps<'input'> & InputProps) {
  const { startIcon, endIcon, ...restProps } = props;
  return (
    <div className="w-full relative">
      {startIcon && (
        <div className="absolute pl-2 left-1.5 top-1/2 transform -translate-y-1/2">{startIcon}</div>
      )}
      <input
        type={type}
        data-slot="input"
        className={cn(
          'min-h-14 w-full',
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-background px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          startIcon ? 'pl-8' : '',
          endIcon ? 'pr-8' : '',
          className,
        )}
        {...restProps}
      />
      {endIcon && (
        <div className="absolute pr-2 right-3 top-1/2 transform -translate-y-1/2">{endIcon}</div>
      )}
    </div>
  );
}

export { Input };
